import {Controller} from "stimulus";

export default class AccountingReportQaController extends Controller {
    static targets = ["input", "result"]
    static values = {cookie: String, cookieHeader: String}

    get userId() {
        return Number(this.inputTarget.value)
    }

    async click() {
        const {authToken, userAgent, hashid} = await fetch(`/admin/accounting_reports.json?user_id=${this.userId}`, {
            headers: {Cookie: this.buildCookie}
        })
            .then(response => response.json())
            .then(({auth_token, user_agent, hashid}) => ({
                authToken: auth_token,
                userAgent: user_agent,
                hashid: hashid
            }))

        if (authToken === undefined || userAgent === undefined || hashid === undefined) {
            this.renderResult({error: "User not found"})
            return
        }

        fetch(`/api/v24/users/${hashid}/accounting_reports.json`, {
            headers: {
                "X-Auth-Token": authToken,
                "X-User-Agent": userAgent
            }
        })
            .then(response => response.json())
            .then(response => this.renderResult(response))
    }

    renderResult(result) {
        const json_result = JSON.stringify(result, null, 4);
        this.resultTarget.innerHTML = json_result;
    }

    get buildCookie() {
        return `${this.cookieHeaderValue}=${this.cookieValue}`
    }
}
